export function canManageFileCategories(accessState = {}, currentUser = null) {
    return !!currentUser && !!accessState.isInternal;
}

export function canManageVaultCategories(accessState = {}, currentUser = null) {
    return !!currentUser && (
        !!accessState.isAdmin
        || (!!accessState.isEmployeeLike && !accessState.isServiceProvider)
    );
}

export function canFilterVaultOwners(accessState = {}, currentUser = null) {
    return !!currentUser && !!accessState.isInternal;
}

export function canShowFilePermissionSection(accessState = {}, canManagePermissions = false) {
    if (accessState.isGuest) {
        return false;
    }

    return !!accessState.isAdmin || !!canManagePermissions;
}

export function filePermissionSectionTitle(accessState = {}) {
    return accessState.isCustomer ? 'Datei teilen' : 'Berechtigungen und Freigaben';
}

export function filePermissionSectionDescription(accessState = {}) {
    return accessState.isCustomer
        ? 'Datei mit weiteren Kunden Ihres Unternehmens teilen.'
        : 'Freigaben getrennt nach intern, Kunden und Gästen verwalten.';
}
